import Entity from '@/entities/entity'

/*!
 * Doreceipt实体
 */
export default class Doreceipt extends Entity<number> {
  returnDoNumber?: number


  shipFrom?: string

  shipTo?: string

  reportedDate?: string

  reportedBy?: string

  lastUpdatedTime?: number

  REMARKS?: string

  status?: string

  docNo?: string
  recStatus?: string
}
